import { Locale, Language } from './types';

const getLocaleForLanguage = (lang: Language): Locale => Locale[lang];

export default getLocaleForLanguage;
